
import {TweenLite} from 'gsap';

const App = require('./app/App');
const DefaultProjectSize = require('./DefaultProjectSize');
const ScrollDownArrow = require('./ScrollArrow');
const ScrollDownArrowControl = ScrollDownArrow(document.querySelector('.arrowdown-block'));
const analyticsEvent = require('../viscomjs/analytics/analyticsEvent');

/* nav */
const nav = require('../../nav.json');

let timeline;
let mouseInteraction;
let menu;
let duoTextblocks;
let textblocks;
let textblocksM;
let app;
let scrollControl;
const progressBar = require('./ProgressBar');
const sound = require('../vereschagin/sound/sound');
let startAnimationDuration = 4.5;

let lastCuePointIndex = -1;
let lastProgressMilestone = 0;

const _initUI = () => {
    menu = require('./side_menu');
}

const _initTextBlocks = () => {
    duoTextblocks = require('./TextBlocks');
    textblocks = require('./ExpandableText');
    textblocksM = require('./ExpandableTextMobileOnly');
}

function init() {
    const initTimeline = require('./ProjectTimelineWithVideo');
    const MouseInteractionSingleton = require('../viscomjs/interactions/MouseInteractionSingleton');
    app = App(document.getElementById('canvasContainer'), DefaultProjectSize, true);

    timeline = initTimeline(app.instance);
    timeline.start();
    startAnimationDuration = timeline.cuePoints[0];

    mouseInteraction = MouseInteractionSingleton();

    _initUI();

    _initTextBlocks();

    return Project;
}

function start() {
    app.instance.start();
    mouseInteraction.start();
    sound.start();

    timeline.transition = startAnimationDuration;
    timeline.playToT(startAnimationDuration);

    progressBar.initCuePoints(timeline.cuePoints.map(value => value / timeline.duration));
    timeline.on('update', _onUpdate);


    setTimeout(() => {
        _startScroll();
    }, 200);

    return Project;
}

const _onUpdate = () => {
    progressBar.setProgress(timeline.progress);

    const i = _getCurrentCuePoint(timeline);
    _storeCurrentCuePoint(i);
    progressBar.setCurrentCuePoint(i);

    _updateScrollDepth(timeline);

    if (timeline.realT >= timeline.duration) {
        _toTheBegining();
    }
};

const _getCurrentCuePoint = timeline => {
    const t = timeline.realT;
    const n = timeline.cuePoints.length;
    let i = 0;
    if (t < timeline.cuePoints[0]) {
        i = -1;
    } else {
        while (i < n && t >= timeline.cuePoints[i]) {
            i++;
        }
        i--;
    }
    return i;
}

const _storeCurrentCuePoint = i => {
    if (i !== lastCuePointIndex) {
        if (i > -1)
            analyticsEvent('Scroll Depth', 'scroll', `Section ${navLabels[i]}`);
        else
            analyticsEvent('Scroll Depth', 'scroll', 'Restart');
        lastCuePointIndex = i;
    }
}

const _updateScrollDepth = timeline => {
    // Scroll Depth
    const p = Math.round(Math.floor(Math.floor(timeline.progress * 100) / 25) * 25);
    if (p !== lastProgressMilestone && p !== 0) {
        analyticsEvent('Scroll Depth', 'scroll', `Percentage ${p}%`);
        lastProgressMilestone = p;
    }
}

function _toTheBegining() {
    // V2
    scrollControl.disable();
    TweenLite.to('.js-fade', 0.5, {
        opacity: 1,
        onComplete: () => {
            timeline.t = 0;
            TweenLite.to('.js-fade', 0.7, {opacity: 1, delay: 0.1,
                onComplete: () => {
                    timeline.transition = startAnimationDuration;
                    timeline.playToT(timeline.cuePoints[0]);
                    // sound.restart();
                    TweenLite.to('.js-fade', 0.6, {opacity: 0,
                        onComplete: () => {
                            scrollControl.enable();
                        }
                    });

                }
            });
        }
    });
}

const navLabels = [];
navLabels.push(nav.menu.one.name);
navLabels.push(nav.menu.two.name);
navLabels.push(nav.menu.three.name);
navLabels.push(nav.menu.four.name);
navLabels.push(nav.menu.five.name);
navLabels.push(nav.menu.six.name);

const navAnalyticsEvent = (type, index) => {
    if (index < 0 || index >= navLabels.length) return;
    analyticsEvent('Navigation', 'click', `${type}: ${navLabels[index]}`);
}

function _startScroll() {
    const initScrollControl = require('./ProjectScrollControl');
    scrollControl = initScrollControl(timeline, startAnimationDuration);
    menu.show();
    duoTextblocks.init();
    textblocks.init();
    textblocksM.init();
    _addListeners();
}

function _addListeners() {
    menu.on('deactivated', () => {
        scrollControl.enable();
    });

    menu.on('activated', () => {
        scrollControl.disable();
    });

    const __onRequest = index => {
        if (index < 0 || index > timeline.cuePoints.length - 1) return;
        timeline.t = timeline.cuePoints[index];
        navAnalyticsEvent('Menu', index);
    };

    menu.on('request', __onRequest);

    progressBar.on('request', index => {

        // V1
         const t = timeline.cuePoints[index];
        timeline.transition = (t - timeline.t) * 0.9;
        timeline.playToT(t);
        navAnalyticsEvent('Scale', index);

    });

    ScrollDownArrowControl.onClick(() => {
        // TODO: move to next cue-point. Set more cue-points
        timeline.transition = 2 * 0.9;
        timeline.playToT(timeline.t + 2.5);

        analyticsEvent('Scroll Arrow', 'click', 'Scroll');
    });

    duoTextblocks.on('expanded', label => {
        scrollControl.disable();
        ScrollDownArrowControl.disable();
        analyticsEvent('KnowMore', 'click', `${label}`);
    });

    duoTextblocks.on('collapsed', () => {
        scrollControl.enable();
        ScrollDownArrowControl.enable();
    });

    textblocks.on('expanded', label => {
        scrollControl.disable();
        ScrollDownArrowControl.disable();
        analyticsEvent('KnowMore', 'click', `${label}`);
    });

    textblocks.on('collapsed', () => {
        scrollControl.enable();
        ScrollDownArrowControl.enable();
    });

    textblocksM.on('expanded', () => {
        scrollControl.disable();
        ScrollDownArrowControl.disable();
    });

    textblocksM.on('collapsed', () => {
        scrollControl.enable();
        ScrollDownArrowControl.enable();
    });
}

const Project = {
    init: init,
    start: start
}

module.exports = Project;



// WEBPACK FOOTER //
// ./js/viscom/vereschagin/Project.js